import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import du from '../media/du.png';
import cvs from '../media/cvs.jpeg';
import RegisterModal from './RegisterModal';

const Hero = () => {
    const [showModal, setShowModal] = useState(false);

    const handleShow = () => setShowModal(true);
    const handleClose = () => setShowModal(false);

return (
    <section id="home" className="hero">
        <div className="container">
            <div className="hero-content">
                <div className="row align-items-center pb-2">
                    <div className="col-lg-1 col-2 text-lg-right">
                        <img src={du} alt="" />
                    </div>
                    <div className="col-lg-10 col-8 text-center">
                        <p className=' mb-0'><strong>COLLEGE OF VOCATIONAL STUDIES, UNIVERSITY OF DELHI</strong>
                        </p>
                        <p className="mb-0 text-center">announces</p>
                    </div>
                    <div className="col-lg-1 col-2 text-right">
                        <img src={cvs} alt="" />
                    </div>
                </div>
                <h1 className="mt-[4rem] mb-[2rem]">National Symposium on<br />Artificial Intelligence</h1>

                    {/* <a href="https://drive.google.com/file/d/1XQNubVz0b_dWBRqzpPx8PBnihdfyca-H/view?usp=sharing"  */}
                <div className="d-flex justify-content-center flex-wrap">
                    {/* <button href="/call-for-papers-2025.pdf" 
                    className="ai-btn ai-btn-primary text-decoration-none" target="_blank" rel="noopener noreferrer" disabled>
                    <i className="fas fa-file-alt me-2"></i>Call for Papers
                    </button> */}
                    {/* <a href="https://forms.gle/nDsQ9yWGtwcQQZaC8"  */}
                    {/* <a href="https://forms.gle/yT87PXVkMQ4E3qRk7" 
                    className="ai-btn ai-btn-primary text-decoration-none" target="_blank" rel="noopener noreferrer">
                    <i className="fas fa-user-plus me-2"></i>Register as Participant
                    </a> */}
                    {/* <div className="ai-btn ai-btn-primary text-[1rem] text-decoration-none py-[15px] px-[40px] my-[2rem]"
                    onClick={() => handleShow()}>
                        <i className="fas fa-user-plus me-2"></i>Register as Participant
                    </div> */}
                </div>
            
                <div className="ai-theme-box">
                    <h2>
                        {/* <i className="fas fa-search me-2"></i> */}
                    Re-examining the Social Sciences through the Lens of AI & IT</h2>
                    <p className='mb-0'>Innovative Intersections: Charting the Future of Social Inquiry in the Digital Age</p>
                </div>
                <p className="hero-subtitle mb-4">
                    <i className="fas fa-atom me-2"></i>Sponsored by ICSSR
                </p>
            </div>
        </div>

        <RegisterModal
            show={showModal} 
            onHide={handleClose} 
        />
    </section>
  );
};

export default Hero;